import {
  Button,
  Card,
  ErrorAlert,
  Header,
  permissionsFillForm,
  permissionsValues,
  success,
  useCustomForm,
  useEffect,
  useLoading,
  useParams,
  useState,
} from "@";
import Skeleton from "./components/Skeleton";
import PermissionsGrid from "./components/PermissionsGrid";
import { getUser, saveUserPermission } from "./utils/api";

const Edit = () => {
  const params = useParams();
  const [error, setError] = useState(false);

  // Breadcrumb links
  const links = [
    { name: "الاعدادات", link: "/all-settings" },
    { name: "موظفي المتجر", link: "/settings-users" },
    { name: "تعديل", link: "" },
  ];

  const { isLoading, loading } = useLoading();

  const {
    watch,
    control,
    setValue,
    handleSubmit,
    isSubmitting,
  } = useCustomForm(permissionsValues);

  // Fetch user data
  async function fetchData() {
    try {
      loading(true);
      const { data } = await getUser(params.id);
      setValue("permissions", permissionsFillForm(data));
    } catch (error) {
      setError(true);
    } finally {
      loading(false);
    }
  }


  // Form submit handler
  const submit = async (data) => {
    try {
      await saveUserPermission(data, params.id);
      await success("تم التعديل بنجاح");
      window.location.reload();
    } catch (error) {}
  };

  useEffect(() => {
    fetchData();
  }, []);

  return (
    <>
      {/* Error alert for API errors */}
      <ErrorAlert reload={fetchData} show={error} />

      {/* Page header with navigation links */}
      <Header title="تعديل الصلاحيات " links={links} />

      <form onSubmit={handleSubmit(submit)}>
        <div className="my-8">
          {isLoading ? (
            <Skeleton />
          ) : (
            <PermissionsGrid
              control={control}
              watch={watch}
              setValue={setValue}
              showGlobalSelectAll={true}
            />
          )}
        </div>

        {/* Submit button */}
        <div className="floating-btn">
        <Button isLoading={isSubmitting} type="submit" title="حفظ البيانات" />
        </div>
      </form>
    </>
  );
};

export default Edit;
